import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ChevronLeft, Phone, MessageCircle } from 'lucide-react';

const DistrictMembers = ({ categoryName, onBack, styles, districtCode }) => {

  const [members, setMembers] = useState([]);

  useEffect(() => {
    fetchMembers();
  }, [categoryName]);

    const dist = sessionStorage.getItem("dist");

  const fetchMembers = async () => {
    try {
      const res = await axios.post(
        'https://lionsdirectoryapi.emedha.in/district/get',
        {
          route: categoryName,
          dist: dist
        }
      );
      setMembers(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div style={styles.scrollArea}>
      {/* Header */}
      <div style={{ backgroundColor: '#0033A0', color: 'white', padding: '15px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <ChevronLeft onClick={onBack} style={{ cursor: 'pointer' }} size={24} />
          <h2 style={{ fontSize: '18px', margin: 0 }}>{categoryName}</h2>
        </div>
      </div>

      <div style={{ padding: '15px' }}>
        {members.map((member, index) => (
          <div key={index} style={{
            backgroundColor: 'white',
            borderRadius: '15px',
            padding: '15px',
            marginBottom: '15px',
            border: '1px solid #eee',
            display: 'flex',
            alignItems: 'center',
            gap: '15px'
          }}>
            {/* Avatar */}
       <div style={{
  width: '60px',
  height: '60px',
  borderRadius: '50%',
  overflow: 'hidden', // so image fits circle
  backgroundColor: '#E9ECEF',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '24px',
  fontWeight: 'bold',
  color: '#6C757D'
}}>
  {member.photo ? (
    <img 
      src={member.photo} 
      alt={member.membershipName} 
      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
    />
  ) : (
          member.membershipName?.charAt(0)
  )}
</div>

      
        

            {/* Member Info */}
            <div style={{ flex: 1 }}>
              <h3 style={{ margin: '0 0 4px 0', fontSize: '16px', fontWeight: '700' }}>
                {member.membershipName}
              </h3>
              <div style={{ fontSize: '14px', color: '#0033A0' }}>
                {member.designation}
              </div>
              <div style={{ fontSize: '13px', color: '#666' }}>
                {member.clubName}
              </div>
            </div>

            {/* Actions */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <a href={`tel:${member.mobile}`}>
                <Phone size={16} />
              </a>

              <a href={`https://wa.me/${member.mobile}`} target="_blank" rel="noreferrer">
                <MessageCircle size={16} />
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DistrictMembers;